import { createContext } from 'react';
export function isAccordionItemSelected(activeItemId, itemId) {
    return Array.isArray(activeItemId) ? activeItemId.includes(itemId) : activeItemId === itemId;
}
const AccordionContext = createContext({ setActiveItemId: () => null });
export { AccordionContext };
